/* unplugin-vue-components disabled */import { render } from "./ExpectHelp.vue?vue&type=template&id=4330f849&scoped=true"
import script from "./ExpectHelp.vue?vue&type=script&lang=js"
export * from "./ExpectHelp.vue?vue&type=script&lang=js"

import "./ExpectHelp.vue?vue&type=style&index=0&id=4330f849&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4330f849"]])

export default __exports__